import React from 'react';
import { Footer, Header } from './components';
import { About, Awards, Contact, Hero, Projects, Skills } from './sections';

const App = () => {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Skills />
      <Projects />
      <Awards />
      <Contact />
      <Footer />
    </>
  );
};

export default App;
